import { pointInter, typeIdObj } from "./buriedPoint";

// studio专区report的大类tab打点
const studioReprotPageLogMes = {
  'StudioReportsDataBrain': {
    pageId: '100604',
    pageName: 'StudioReportsDataBrain',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsArchivedMarketReport': {
    pageId: '100605',
    pageName: 'StudioReportsArchivedMarketReport',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsSensorTower': {
    pageId: '100606',
    pageName: 'StudioReportsSensorTower',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsDataAi': {
    pageId: '100607',
    pageName: 'StudioReportsDataAi',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsStreamHatchet': {
    pageId: '100608',
    pageName: 'StudioReportsStreamHatchet',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsNPD': {
    pageId: '100609',
    pageName: 'StudioReportsNPD',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsStatista': {
    pageId: '100610',
    pageName: 'StudioReportsStatista',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsFamitsu': {
    pageId: '100611',
    pageName: 'StudioReportsFamitsu',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsTwitter': {
    pageId: '100612',
    pageName: 'StudioReportsTwitter',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsFandom': {
    pageId: '100613',
    pageName: 'StudioReportsFandom',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'StudioReportsOthers': {
    pageId: '100614',
    pageName: 'StudioReportsOthers',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
};

// 页面打点配置表
export const PageLogMes: { [key: string]: pointInter } = {
  /** PC端-首页 首页*/
  'dataBrainHome': {
    pageId: '100101',
    pageName: 'homeExplore',
    pagePath: 'home/Explore',
    typeId: typeIdObj.home,
  },
  'dataBrainHomeTrueDataDetail': {
    pageId: '100102',
    pageName: 'homeTrueDataDetail',
    pagePath: 'home/Latest Public True Data Contribution/More',
    typeId: typeIdObj.home,
  },
  /** start--VersionHistory */
  'versionPreview': {
    pageId: '100201',
    pageName: 'versionHistoryPreview',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'versionDataBrain': {
    pageId: '100202',
    pageName: 'versionHistoryDataBrainDetail',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'versionDashboard': {
    pageId: '100203',
    pageName: 'versionHistoryDashboardDetail',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'versionIntelligence': {
    pageId: '100204',
    pageName: 'versionHistoryIntelligenceDetail',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'versionOpinions': {
    pageId: '100205',
    pageName: 'versionHistoryOpinionsDetail',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'versionGPOP': {
    pageId: '100206',
    pageName: 'versionHistoryGPOPDetail',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'versionDatalab': {
    pageId: '100207',
    pageName: 'versionHistoryDatalabDetail',
    pagePath: 'home/components/VersionPopup',
    typeId: typeIdObj.home,
  },
  'studioCompetitors': {
    pageId: '100401',
    pageName: 'competitors',
    pagePath: '/competitors',
    typeId: typeIdObj.studio,
  },
  'studioOpinion': {
    pageId: '101201',
    pageName: 'opinions',
    pagePath: '/opinions',
    typeId: typeIdObj.studio,
  },
  'studioOpinionV2': {
    pageId: '101801',
    pageName: 'opinions-v2',
    pagePath: '/opinions-v2',
    typeId: typeIdObj.studio,
  },
  'studioInGameAnalytics': {
    pageId: '101301',
    pageName: 'inGameAnalytics',
    pagePath: '/inGameAnalytics',
    typeId: typeIdObj.studio,
  },
  'studioReports': {
    pageId: '100601',
    pageName: 'reports',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'studioReportsMarketing': {
    pageId: '100602',
    pageName: 'reportsMarketing',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'studioReportsInGame': {
    pageId: '100603',
    pageName: 'reportsInGameAnalytics',
    pagePath: '/reports',
    typeId: typeIdObj.studio,
  },
  'studioPresentation': {
    pageId: '902301',
    pageName: 'presentation',
    pagePath: '/presentation',
    typeId: typeIdObj.studio,
  },
  // Studio Casual Hub Competitors 页面
  studioCasualHubCompetitors: {
    pageId: '903101',
    pageName: 'Casual Studio Competitors',
    extInfo: 'Casual Studio Competitors',
    pagePath: '/home/competitors',
    typeId: 'studio_pc',
    uidType: 'studio_id',
    uid: '',
    gameName: '',
  },
  ...studioReprotPageLogMes,
  /** end--VersionHistory */

  /** PC端-搜索 首页*/
  'searchHome': {
    pageId: '100301',
    pageName: 'dataBrainHomeSearch',
    pagePath: '/search',
    typeId: typeIdObj.home,
  },

  // 搜索结果游戏
  'searchDetail': {
    extInfo: '100302',
    typeId: typeIdObj.home,
  },

  'chatgpt': {
    pageId: '100501',
    pageName: 'chatgpt',
    pagePath: '/chatgpt',
    typeId: typeIdObj.home,
  },

};

export const dbhBtnLogMes = {
  /** 首次进入 表格提示信息*/
  'studioReportisDetail': {
    pageId: '100601',
    buttonId: '100601001',
    extInfo: 'studioReports查看PDF',
    typeId: typeIdObj.studio,
  },
  'studioReportisDownload': {
    pageId: '100601',
    buttonId: '100601002',
    extInfo: 'studioReportisDownload',
    typeId: typeIdObj.studio,
  },
  'studioReportisShare': {
    pageId: '100601',
    buttonId: '100601003',
    extInfo: 'studioReports分享',
    typeId: typeIdObj.studio,
  },
  'studioReportisSearch': {
    pageId: '100601',
    buttonId: '100601004',
    extInfo: 'studioReports搜索',
    typeId: typeIdObj.studio,
  },
  // 智能搜索 点击情报页面跳转按钮
  intelligencePageAIAccess: {
    pageId: '100101',
    buttonId: '100101016',
    extInfo: '智能搜索情报页面AI直达',
    typeId: typeIdObj.home,
  },
  // 首页 My Shortcuts 新增收藏确认
  homeShortcutsAdd: {
    pageId: '100101',
    buttonId: '100101017',
    extInfo: '首页 My Shortcuts 新增收藏确认',
    typeId: typeIdObj.home,
  },
  // 首页 My Shortcuts 收藏点击跳转
  homeShortcutsClick: {
    pageId: '100101',
    buttonId: '100101018',
    extInfo: '首页 My Shortcuts 收藏点击跳转',
    typeId: typeIdObj.home,
  },
  // 首页 New Features 点击 More
  homeNewFeaturesMore: {
    pageId: '100101',
    buttonId: '100101019',
    extInfo: '首页 New Features 点击 More',
    typeId: typeIdObj.home,
  },
  // 首页 New Features 推荐点击跳转
  homeNewFeaturesClick: {
    pageId: '100101',
    buttonId: '100101020',
    extInfo: '首页 New Features 推荐点击跳转',
    typeId: typeIdObj.home,
  },
  // Studio Casual Hub Competitors 页面 Key Games 模块下载
  studioCasualHubCompetitorsKeyGamesDownload: {
    pageId: '903101',
    buttonId: '903101001',
    extInfo: 'Studio Casual Hub Competitors 页面 Key Games 模块下载',
    typeId: typeIdObj.studio,
  },
  // Studio Casual Hub Competitors 页面 Top Publishers 模块下载
  studioCasualHubCompetitorsTopPublishersDownload: {
    pageId: '903101',
    buttonId: '903101002',
    extInfo: 'Studio Casual Hub Competitors 页面 Top Publishers 模块下载',
    typeId: typeIdObj.studio,
  },
  // Studio Casual Hub Competitors 页面 Top Publishers 模块厂商展开
  studioCasualHubCompetitorsTopPublishersExpand: {
    pageId: '903101',
    buttonId: '903101003',
    extInfo: 'Studio Casual Hub Competitors 页面 Top Publishers 模块厂商展开',
    typeId: typeIdObj.studio,
  },
};

export const dbhAISearchSwitchBtnLogMes = {
  homeHeader: {
    pageId: '100101',
    openButtonId: '100101005',
    closeButtonId: '100101006',
    openExtInfo: '首页AI Search Switch开启',
    closeExtInfo: '首页AI Search Switch关闭',
    typeId: typeIdObj.home,
  },
  navHeader: {
    pageId: '100101',
    openButtonId: '100101005',
    closeButtonId: '100101006',
    openExtInfo: '导航栏AI Search Switch开启',
    closeExtInfo: '导航栏AI Search Switch关闭',
    typeId: typeIdObj.home,
  },
};
